

import styled from 'styled-components';
import { Colors } from '@brg/ui';

export const PageTitle = styled.h1`
    font-weight: 600;
    font-size: 28px;
    line-height: 29px;
    letter-spacing: -0.02em;
    margin-bottom: 60px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const Text = styled.div`
    margin-bottom: 96px;
    color: ${(p) => p.theme.legals.textColor};
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.02em;
    p {
        margin-bottom: 32px;
        &.bold {
            font-weight: bold;
            margin-bottom: 16px;
        }
    }

    a {
        text-decoration: none;
        color: ${(p) => p.theme.legals.link};
        transition: color 0.2s;
        &:hover {
            color: ${(p) => p.theme.legals.linkHover};
        }
    }

    ul {
        margin-top: 16px;
        list-style-type: disc;
        padding-left: 65px;
        &.transparent {
            list-style: none;
        }
        > li {
            margin-bottom: 8px;
        }
    }

    ol {
        > li {
            margin-bottom: 16px;
        }
    }
    &.sub-point {
        margin-bottom: 0;
        p {
            padding-left: 24px;
        }
    }

`;

export const SectionsList = styled.ol`
    list-style: none;
    counter-reset: my-counter;
    margin: 0;
    padding: 0;

    > li {
        display: flex;
        &::before {
            counter-increment: my-counter;
            content: counter(my-counter) '.';
            font-weight: bold;
            font-size: 28px;
            line-height: 29px;
            letter-spacing: -0.02em;
            color: ${Colors.geoWhite100};
            min-width: 32px;
            margin-right: 8px;
        }
    }
`;

export const Section = styled.section`
    margin-bottom: 96px;
    :last-child {
        margin-bottom: 0;
    }
`;

export const SectionTitle = styled.h2`
    font-weight: bold;
    font-size: 28px;
    line-height: 29px;
    letter-spacing: -0.02em;
    margin-bottom: 64px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const SectionSubtitle = styled.h3`
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.02em;
    margin-bottom: 64px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const SectionContent = styled(Text)`
    margin-left: 150px;
    &.no-padding {
        margin: 0;
    }
    a:hover {
        color: ${(p) => p.theme.legals.linkHover};
    }
    color: ${(p) => p.theme.legals.textColor};
  
    table {
      border-collapse: collapse;
      border-color: lightgray;
      width: 100%;
      margin-bottom: 32px;
      
      th, td {
        border: 1px solid lightgray;
        padding: 5px;
      }
    }

    .letter-order {
        list-style-type: none;
        p {
            margin-bottom: 16px;
        }
        li {
            &::before {
                margin-right: 5px;
                font-weight: bold;
            }
        }
        li:nth-child(1) {
            &::before {
                content: 'а)';
            }
        }
        li:nth-child(2) {
            &::before {
                content: 'б)';
            }
        }
        li:nth-child(3) {
            &::before {
                content: 'в)';
            }
        }
        li:nth-child(4) {
            &::before {
                content: 'г)';
            }
        }
        li:nth-child(5) {
            &::before {
                content: 'д)';
            }
        }
    }
`;

export const BorderedSection = styled(Text)`
  font-weight: 600;
  border: 1px solid;
  padding: 32px;
  margin-bottom: 32px;
`


import styled from 'styled-components';
import { Colors } from '@brg/ui';

export const PageTitle = styled.h1`
    font-weight: 600;
    font-size: 28px;
    line-height: 29px;
    letter-spacing: -0.02em;
    margin-bottom: 60px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const Text = styled.div`
    margin-bottom: 96px;
    color: ${(p) => p.theme.legals.textColor};
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.02em;
    p {
        margin-bottom: 32px;
        &.bold {
            font-weight: bold;
            margin-bottom: 16px;
        }
    }

    a {
        text-decoration: none;
        color: ${(p) => p.theme.legals.link};
        transition: color 0.2s;
        &:hover {
            color: ${(p) => p.theme.legals.linkHover};
        }
    }

    ul {
        margin-top: 16px;
        list-style-type: disc;
        padding-left: 65px;
        &.transparent {
            list-style: none;
        }
        > li {
            margin-bottom: 8px;
        }
    }

    ol {
        > li {
            margin-bottom: 16px;
        }
    }
    &.sub-point {
        margin-bottom: 0;
        p {
            padding-left: 24px;
        }
    }

`;

export const SectionsList = styled.ol`
    list-style: none;
    counter-reset: my-counter;
    margin: 0;
    padding: 0;

    > li {
        display: flex;
        &::before {
            counter-increment: my-counter;
            content: counter(my-counter) '.';
            font-weight: bold;
            font-size: 28px;
            line-height: 29px;
            letter-spacing: -0.02em;
            color: ${Colors.geoWhite100};
            min-width: 32px;
            margin-right: 8px;
        }
    }
`;

export const Section = styled.section`
    margin-bottom: 96px;
    :last-child {
        margin-bottom: 0;
    }
`;

export const SectionTitle = styled.h2`
    font-weight: bold;
    font-size: 28px;
    line-height: 29px;
    letter-spacing: -0.02em;
    margin-bottom: 64px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const SectionSubtitle = styled.h3`
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.02em;
    margin-bottom: 64px;
    color: ${(p) => p.theme.legals.textColor};
`;

export const SectionContent = styled(Text)`
    margin-left: 150px;
    &.no-padding {
        margin: 0;
    }
    a:hover {
        color: ${(p) => p.theme.legals.linkHover};
    }
    color: ${(p) => p.theme.legals.textColor};
  
    table {
      border-collapse: collapse;
      border-color: lightgray;
      width: 100%;
      margin-bottom: 32px;
      
      th, td {
        border: 1px solid lightgray;
        padding: 5px;
      }
    }

    .letter-order {
        list-style-type: none;
        p {
            margin-bottom: 16px;
        }
        li {
            &::before {
                margin-right: 5px;
                font-weight: bold;
            }
        }
        li:nth-child(1) {
            &::before {
                content: 'а)';
            }
        }
        li:nth-child(2) {
            &::before {
                content: 'б)';
            }
        }
        li:nth-child(3) {
            &::before {
                content: 'в)';
            }
        }
        li:nth-child(4) {
            &::before {
                content: 'г)';
            }
        }
        li:nth-child(5) {
            &::before {
                content: 'д)';
            }
        }
    }
`;

export const BorderedSection = styled(Text)`
  font-weight: 600;
  border: 1px solid;
  padding: 32px;
  margin-bottom: 32px;
`
